import { SecondaryShell } from '@/app/layout/SecondaryShell';
import { ProfileNav } from '@/features/profile/ProfileNav';

/**
 * The shell for `/profile/*` and `/subscription/*` (§ Profiel): its own
 * full-page `SecondaryShell` — same one Beheer uses — with `ProfileNav` as
 * the sole left-hand nav, not a second nav next to the main `Sidebar`.
 * Reached only through the account dropdown, never one of the main-menu
 * sections.
 */
export function ProfileShell() {
  return <SecondaryShell nav={(onNavigate) => <ProfileNav onNavigate={onNavigate} />} />;
}
